<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <form @submit.prevent="submitForm">

                <!-- Applicant Details Section -->
                <h2 class="text-xl font-bold mb-4">By Admin</h2>
                <div class="flex flex-wrap -mb-8 -mr-6">

                    <!-- Training Radio Button -->
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <label class="form-label">{{ __('Training') }}</label>
                        <div class="mt-2 flex items-center">
                            <div class="mr-6">
                                <input type="radio" id="yes" value="yes" v-model="form.training_required"
                                       class="mr-2"
                                />
                                {{ __('Yes') }}
                            </div>
                            <div>
                                <input type="radio" id="no" value="no" v-model="form.training_required"
                                       class="mr-2"
                                />
                                {{ __('No') }}
                            </div>
                        </div>
                    </div>

                    <select-input v-model="form.selected_employee" :error="form.errors?.selected_employee"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                    >
                        <option value="">{{ __('Select Employee') }}</option>
                        <!-- Placeholder option with empty string -->
                        <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                            {{ employee.name }}
                        </option>
                    </select-input>

                    <!-- Date From-To -->
                    <text-input v-model="form.from_date" :error="form.errors?.from_date || ''"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('From Date')" type="date"
                                :max="currentDate"
                                @focus.native="$event.target.showPicker()"
                    />
                    <text-input v-model="form.to_date" :error="form.errors?.to_date"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('To Date')" type="date"
                                :max="currentDate"
                                @focus.native="$event.target.showPicker()"
                    />

                    <!-- Remark by Admin -->
                    <text-input v-model="form.remark_by_admin" :error="form.errors?.remark_by_admin || ''"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Remark by Admin')"
                    />

                </div>


                <h2 class="text-xl font-bold mt-6 mb-4">By Trainer Employee</h2>
                <div class="flex flex-wrap -mb-8 -mr-6">
                    <!-- Training Start Date -->
                  <text-input v-model="form.from_date" :error="form.errors?.training_start_date || ''"
                              class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Training Start Date')" type="date"
                              :max="currentDate"
                              @focus.native="$event.target.showPicker()"/>

                    <!-- Issue Articles -->
                    <text-input v-model="form.issue_articles" :error="form.errors?.issue_articles"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Issue Articles')"
                    />

                    <!-- Remarks -->
                    <text-input v-model="form.trainer_remarks" :error="form.errors?.trainer_remarks"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Remarks')"
                    />

                    <!-- Positive Points -->
                    <textarea-input v-model="form.positive_points" :error="form.errors?.positive_points"
                                    class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Positive Points')"
                    />

                    <!-- Negative Points -->
                    <textarea-input v-model="form.negative_points" :error="form.errors?.negative_points"
                                    class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Negative Points')"
                    />

                    <!-- Suggestions -->
                    <textarea-input v-model="form.suggestions" :error="form.errors?.suggestions"
                                    class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Suggestions')"
                    />

                    <!-- Completion Checkbox with Date -->
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <label class="form-label">{{ __('Complete') }}</label>
                        <div class="mt-2 flex items-center">
                            <div class="mr-6">
                                <input type="radio" id="complete_yes" value="yes" v-model="form.training"
                                       class="mr-2"
                                />
                                {{ __('Yes') }}
                            </div>
                            <div>
                                <input type="radio" id="complete_no" value="no" v-model="form.training"
                                       class="mr-2"
                                />
                                {{ __('No') }}
                            </div>
                        </div>
                    </div>

                    <text-input v-model="form.to_date" :error="form.errors?.to_date"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Completion Date')" type="date"
                                :max="currentDate"
                                @focus.native="$event.target.showPicker()"
                    />
                </div>

                <h2 class="text-xl font-bold mt-6 mb-4">Employee Details</h2>

                <div class="flex flex-wrap -mb-8 -mr-6">
                    <div class="pb-8 pr-6 w-full lg:w-1/4">
                        <h3 class="font-bold mb-4">Employee Photo</h3>
                        <file-pond
                            type="file"
                            name="employee_photo"
                            @change="handlePhotoChange($event, 'employee')"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                        <div v-if="photos.employee" class="mt-4 photo-container">
                            <img :src="photos.employee" alt="Employee Photo" class="w-1/2 photo-preview"/>
                        </div>
                    </div>

                    <!-- Father Photo Upload Section -->
                    <div class="pb-8 pr-6 w-full lg:w-1/4">
                        <h3 class="font-bold mb-4">Father's Photo</h3>
                        <file-pond
                            type="file"
                            name="father_photo"
                            @change="handlePhotoChange($event, 'father')"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                        <div v-if="photos.father" class="mt-4 photo-container">
                            <img :src="photos.father" alt="Father's Photo" class="w-1/2 photo-preview"/>
                        </div>
                    </div>

                    <!-- Mother Photo Upload Section -->
                    <div class="pb-8 pr-6 w-full lg:w-1/4">
                        <h3 class="font-bold mb-4">Mother's Photo</h3>
                        <file-pond
                            type="file"
                            name="mother_photo"
                            @change="handlePhotoChange($event, 'mother')"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                        <div v-if="photos.mother" class="mt-4 photo-container">
                            <img :src="photos.mother" alt="Mother's Photo" class="w-1/2 photo-preview"/>
                        </div>
                    </div>

                    <!-- Spouse Photo Upload Section -->
                    <div class="pb-8 pr-6 w-full lg:w-1/4">
                        <h3 class="font-bold mb-4">Spouse's Photo</h3>
                        <file-pond
                            type="file"
                            name="spouse_photo"
                            @change="handlePhotoChange($event, 'spouse')"
                            class="form-input w-full photo-preview"
                            accept="image/*"
                        />
                        <div v-if="photos.spouse" class="mt-4 photo-container">
                            <img :src="photos.spouse" alt="Spouse's Photo" class="w-1/2 photo-preview"/>
                        </div>
                    </div>


                    <!-- Employee No. -->
                    <text-input v-model="form.employee_no" :error="form.errors?.employee_no"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Employee No.')"
                    />

                    <!-- User ID -->
                    <text-input v-model="form.user_id" :error="form.errors?.user_id"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('User ID')"
                    />


                    <text-input v-model="form.joining_date" :error="form.errors?.joining_date"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Joining Date')" type="date"
                    />

                    <!-- Status -->
                    <select-input v-model="form.status" :error="form.errors?.status"
                                  class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Status')"
                    >
                        <option value="active">{{ __('Active') }}</option>
                        <option value="dropout">{{ __('Dropout') }}</option>
                    </select-input>

                    <!-- Salutation -->
                    <select-input v-model="form.salutation" :error="form.errors?.salutation"
                                  class="pb-8 pr-6 w-full lg:w-1/6" :label="__('Salutation')"
                    >
                        <option value="Mr.">{{ __('Mr.') }}</option>
                        <option value="Ms.">{{ __('Ms.') }}</option>
                        <option value="Mrs.">{{ __('Mrs.') }}</option>
                    </select-input>

                    <!-- Name -->
                    <text-input v-model="form.name" :error="form.errors?.name"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Name')"
                    />
                </div>


                <h2 class="text-xl font-bold mt-6 mb-4">Employement Details</h2>

                <div class="flex flex-wrap -mb-8 -mr-6">

                    <!-- Employment Type -->
                    <select-input v-model="form.employment_type" :error="form.errors?.employment_type"
                                  class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Employment Type')"
                    >
                        <option value="Probation">{{ __('Probation') }}</option>
                        <option value="Regular">{{ __('Regular') }}</option>
                        <option value="Contract Full Time">{{ __('Contract Full Time') }}</option>
                        <option value="Contract Part Time">{{ __('Contract Part Time') }}</option>
                        <option value="Placement Agency">{{ __('Placement Agency') }}</option>
                    </select-input>

                    <text-input v-model="form.designation" :error="form.errors.designation"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Designation')"
                    />
                    <text-input v-model="form.responsibility" :error="form.errors.responsibility"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Responsibility')"
                    />
                    <text-input v-model="form.duty" :error="form.errors.duty"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Duty')"
                    />


                </div>
                <h2 class="text-xl font-bold mt-6 mb-4">Family Details</h2>

                <div class="flex flex-wrap -mb-8 -mr-6">
                    <!-- Father Name -->
                    <text-input v-model="form.father_name" :error="form.errors?.father_name"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Father Name')"
                    />

                    <!-- Mother Name -->
                    <text-input v-model="form.mother_name" :error="form.errors?.mother_name"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Mother Name')"
                    />

                    <!-- Date of Birth -->
                    <text-input v-model="form.date_of_birth" :error="form.errors?.date_of_birth"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Date of Birth')" type="date"
                    />

                    <div class="flex flex-wrap w-full">
                        <!-- Gender Radio Buttons -->
                        <div class="pb-8 pr-6 lg:w-1/2">
                            <label class="form-label">{{ __('Gender') }}</label>
                            <div>
                                <input type="radio" id="male" value="male" v-model="form.gender"/> Male
                                <input type="radio" id="female" value="female" v-model="form.gender" class="ml-4"/>
                                Female
                            </div>
                        </div>

                        <!-- Marital Status Radio Buttons -->
                        <div class="pb-8 pr-6 w-full lg:w-1/2">
                            <label class="form-label">{{ __('Marital Status') }}</label>
                            <div>
                                <input type="radio" id="married" value="married" v-model="form.marital_status"/> Married
                                <input type="radio" id="unmarried" value="unmarried" v-model="form.marital_status"
                                       class="ml-4"
                                /> Unmarried
                            </div>
                        </div>
                    </div>

                    <!-- Conditional Spouse Name and Occupation -->
                    <div v-if="form.marital_status === 'married'" class="pb-8 pr-6 w-full lg:w-1/2">
                        <text-input v-model="form.spouse_name" :error="form.errors?.spouse_name"
                                    class="w-full lg:w-full" :label="__('Spouse Name')"
                        />
                    </div>
                    <div v-if="form.marital_status === 'married'" class="pb-8 pr-6 w-full lg:w-1/2">
                        <text-input v-model="form.spouse_occupation" :error="form.errors?.spouse_occupation"
                                    class="w-full lg:w-full" :label="__('Spouse Occupation')"
                        />
                    </div>

                    <!-- Contact Information -->
                    <text-input v-model="form.contact_number" :error="form.errors?.contact_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Contact Number')" type="tel"
                    />

                    <text-input v-model="form.alternative_contact" :error="form.errors?.alternative_contact"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Alternative Contact Number')"
                    />
                    <text-input v-model="form.whatsapp_number" :error="form.errors?.whatsapp_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('WhatsApp Number')" type="tel"
                    />
                    <text-input v-model="form.home_contact_number" :error="form.errors?.home_contact_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Home Contact Number')"
                                placeholder="e.g., 1234-567-890"
                    />

                    <!-- Email -->
                    <text-input v-model="form.email" :error="form.errors?.email"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Email')" type="email"
                    />

                    <!-- Aadhaar Number -->
                    <text-input v-model="form.aadhaar_number" :error="form.errors?.aadhaar_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Aadhaar Number')" type="number"
                    />

                    <!-- Address -->
                    <textarea-input v-model="form.current_address" :error="form.errors?.current_address"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Current Address')"
                    />
                    <textarea-input v-model="form.permanent_address" :error="form.errors?.permanent_address"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Permanent Address')"
                    />

                    <!-- Category -->
                    <select-input v-model="form.category" :error="form.errors?.category"
                                  class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Category')"
                    >
                        <option value="gen">{{ __('General') }}</option>
                        <option value="obc">{{ __('OBC') }}</option>
                        <option value="sc">{{ __('SC') }}</option>
                        <option value="st">{{ __('ST') }}</option>
                        <option value="other">{{ __('Other') }}</option>
                    </select-input>
                    <text-input v-if="form.category === 'other'" v-model="form.other_category"
                                :error="form.errors?.other_category"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Please specify Other Category')"
                    />

                    <!-- PAN Number -->
                    <text-input v-model="form.pan_number" :error="form.errors?.pan_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('PAN Number')"
                    />

                    <!-- Bank Details -->
                    <text-input v-model="form.bank_name_branch" :error="form.errors?.bank_name_branch"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Bank Name & Branch')"
                    />
                    <text-input v-model="form.bank_account_number" :error="form.errors?.bank_account_number"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Bank Account Number')"
                    />
                    <text-input v-model="form.ifsc_code" :error="form.errors?.ifsc_code"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('IFSC Code')"
                    />

                    <!-- Qualification / Degree -->
                    <text-input v-model="form.qualification" :error="form.errors?.qualification"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Qualification / Degree')"
                    />

                    <!-- Teaching Details -->
                    <text-input v-model="form.teaching_classes" :error="form.errors?.teaching_classes"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Teaching Class(es)')"
                    />
                    <text-input v-model="form.teaching_subjects" :error="form.errors?.teaching_subjects"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Teaching Subject(s)')"
                    />

                    <!-- Total Experience -->
                    <text-input v-model="form.total_experience" :error="form.errors?.total_experience"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Total Experience')"
                    />


                        <

                    <!-- Academic Qualifications -->
                    <h3 class="form-label w-full">{{ __('Academic Qualifications') }}</h3>
                    <table class="w-full whitespace-nowrap mb-2">
                        <thead>
                        <tr class="text-left font-bold">
                            <th class="px-6 pt-6 pb-4">STD</th>
                            <th class="px-6 pt-6 pb-4">Year of Passing</th>
                            <th class="px-6 pt-6 pb-4">Roll No.</th>
                            <th class="px-6 pt-6 pb-4">University / Board / College</th>
                            <th class="px-6 pt-6 pb-4">Subject(s)</th>
                            <th class="px-6 pt-6 pb-4">Percentage/Division</th>
                            <th class="px-6 pt-6 pb-4">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(row, index) in rows"
                            :key="row.id"
                            class="hover:bg-gray-100 focus-within:bg-gray-100"
                        >
                            <td class="border-t">
                                <input class="form-input" type="text" v-model="row.std" @blur="saveRow(index)"/>
                            </td>
                            <td class="border-t">
                                <input class="form-input" type="number" v-model="row.year_of_passing"
                                       @blur="saveRow(index)"
                                />
                            </td>
                            <td class="border-t">
                                <input class="form-input" type="number" v-model="row.roll_no" @blur="saveRow(index)"/>
                            </td>
                            <td class="border-t">
                                <input class="form-input" type="text" v-model="row.university" @blur="saveRow(index)"/>
                            </td>
                            <td class="border-t">
                                <input class="form-input" type="text" v-model="row.subjects" @blur="saveRow(index)"/>
                            </td>
                            <td class="border-t">
                                <input class="form-input" type="number" v-model="row.percentage"
                                       @blur="saveRow(index)"
                                />
                            </td>
                            <td class="border-t">
                                <button @click="deleteRow(index)" class="btn btn-danger">Delete</button>
                            </td>
                        </tr>

                        <!-- Add Row Button -->
                        <tr>
                            <td colspan="7" class="text-center">
                                <button @click="addRow" class="btn btn-success">Add</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <!-- Any Other Skill -->
                    <text-input v-model="form.other_skills" :error="form.errors?.other_skills"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Any Other Skill')"
                    />

                    <!-- Holiday List -->
                    <select-input v-model="form.holiday_list" :error="form.errors?.holiday_list"
                                  class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Holiday List')"
                    >
                        <option value="office_staff">{{ __('Office Staff') }}</option>
                        <option value="academic_staff">{{ __('Academic Staff') }}</option>
                        <option value="iv_grade_staff">{{ __('IV Grade Staff') }}</option>
                        <option value="drivers">{{ __('Drivers') }}</option>
                    </select-input>

                    <!-- Document Attachments -->
                    <div class="pb-8 pr-6 w-full lg:w-full">
                        <div class="file-upload-container">

                            <div v-for="(document, index) in documentUploads" :key="index" class="mb-6 lg:w-1/2">
                                <h3 class="font-bold mb-2">Upload Document {{ index + 1 }}</h3>

                                <!-- FilePond for Drag and Drop -->
                                <file-pond
                                    name="documents"
                                    label-idle="Drag & Drop your files or <span class='filepond--label-action'>Browse</span>"
                                    allow-multiple="false"
                                    ref="pond"
                                    @addfile="fileAdded($event, index)"
                                    v-show="!document.uploaded"
                                >
                                </file-pond>

                                <!-- Input for Document Name -->
                                <label for="documentName" class="block font-bold mb-2">Document Name:</label>
                                <input
                                    id="documentName"
                                    v-model="document.name"
                                    name="document_names[]"
                                    type="text"
                                    class="form-input w-full"
                                    placeholder="Enter document name"
                                />

                                <!-- Preview of the selected file -->
                                <div v-if="document.preview" class="mt-4">
                                    <h4 class="font-bold mb-2">Document Preview:</h4>
                                    <img v-if="isImage(document.preview)" :src="document.preview" alt="Preview"
                                         class="w-1/2"
                                    />
                                    <a v-else :href="document.preview" target="_blank" class="text-blue-500 underline">
                                        {{ document.name }} (Click to preview)
                                    </a>
                                </div>

                                <!-- Add Document Button -->
                                <button
                                    v-if="document.selectedFile"
                                    class="btn btn-success mt-4"
                                    @click="uploadDocument(index)"
                                >
                                    Add Document
                                </button>

                                <div v-if="document.uploaded" class="mt-4">
                                    <p class="text-green-600">Document {{ document.name }} uploaded successfully!</p>
                                </div>
                            </div>

                            <!-- Button to Add More Document Upload Fields -->
                            <button class="btn btn-primary mt-4" @click="addMoreDocument">
                                Add More Document
                            </button>

                            <!-- Display Uploaded Documents -->
                            <div v-if="uploadedDocuments.length > 0" class="mt-4">
                                <h3 class="font-bold">Uploaded Documents:</h3>
                                <ul>
                                    <li v-for="(doc, index) in uploadedDocuments" :key="index">
                                        {{ doc.name }} - {{ doc.path }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="flex items-center justify-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo mx-auto" type="submit">{{
                            __('Submit')
                        }}
                    </loading-button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import FileUploader from '@/Shared/FileUploader'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import {ref} from 'vue'

// Register the component globally
const FilePond = vueFilePond()

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        FileUploader,
        FilePond,
    },
    layout: Layout,

    data() {
        const rows = ref([
            {id: 1, std: '10th', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 2, std: '12th', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 3, std: 'Graduation', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {
                id: 4,
                std: 'Post Graduation',
                year_of_passing: 30,
                roll_no: '',
                university: '',
                subjects: '',
                percentage: '',
            },
            {id: 5, std: 'B.ED', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 6, std: 'D.E.LED', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 7, std: 'BSTC', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 8, std: 'NTT', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},
            {id: 8, std: 'Other', year_of_passing: 30, roll_no: '', university: '', subjects: '', percentage: ''},

        ])

        const newRow = ref({name: '', age: null})

        const addRow = () => {
            // Check if the newRow fields are not empty
            // Assign a unique ID to each new row
            const newId = Date.now()

            // Push the new row into the rows array
            rows.value.push({
                id: newId,
                name: newRow.value.name,
                age: newRow.value.age,
            })

            // Clear the newRow fields after adding
            newRow.value = {name: '', age: ''}
        }

        const saveRow = (index) => {
            // Here you can handle saving the data to a server or handling validation.
            console.log(`Row ${index} saved`, rows.value[index])
        }

        const deleteRow = (index) => {
            rows.value.splice(index, 1)
        }

        return {
            photos: {
                employee: null,
                father: null,
                mother: null,
                spouse: null,
            }, // Stores the preview URLs for the employee and family photos
            files: [], // Stores the files selected in FilePond
            selectedFile: null, // Stores the selected file
            documentName: '', // The user-defined name for the document
            uploadedDocuments: [], // Stores the uploaded documents
            fileUploaded: false, // Track if file is uploaded
            rows,
            newRow,
            addRow,
            saveRow,
            deleteRow,
            addChildren,
            removeChildren,
            addDocument,
            removeDocument,
            form: {
                qualifications: [],
                newQualification: {name: '', institution: '', year: ''},
                name_of_applicant: '',
                father_name: '',
                date_of_birth: '',
                address: '',
                phone_no: '',
                marital_status: [],
                other_qualities: '',
                schooling_medium: '',
                schooling_name: '',
                favourite_subjects: '',
                teaching_class_limit: '',
                prefer_teaching_reason: '',
                join_reason: '',
                positive_points: '',
                negative_points: '',
                commitments: '',
                about_academy: '',
                previous_experience: '',
                leave_reason: '',
                salary_expectation: '',
                continue_duration: '',
                date: '',
                errors: {},
                processing: false,
                training: null,
                selected_employee: '',
                from_date: '',
                to_date: '',
                remark_by_admin: '',
                training_start_date: '',
                issue_articles: '',
                trainer_remarks: '',
                suggestions: '',
                completion: false,
                completion_date: '',
                employee_photo: null,
                father_photo: null,
                mother_photo: null,
                spouse_photo: null,
                joining_date: '',
                salutation: '',
                employee_no: '',
                user_id: '',
                status: 'active',
                name: '',
                employment_type: '',
                responsibility: '',
                designation: '',
                duty: '',
                mother_name: '',
                gender: '',
                spouse_name: '',
                spouse_occupation: '',
                contact_number: '',
                whatsapp_number: '',
                alternative_contact: '',
                home_contact_number: '',
                email: '',
                current_address: '',
                permanent_address: '',
                aadhaar_number: '',
                category: '',
                other_category: '',
                pan_number: '',
                bank_name_branch: '',
                bank_account_number: '',
                ifsc_code: '',
                qualification: '',
                teaching_classes: '',
                teaching_subjects: '',
                total_experience: '',
                student_name: '',
                student_class: '',
                school_name: '',
                academic_qualifications: [
                    {name: '10th', year_of_passing: '', roll_number: '', university: '', subjects: '', percentage: ''},
                    {name: '12th', year_of_passing: '', roll_number: '', university: '', subjects: '', percentage: ''},
                    {
                        name: 'Graduation',
                        year_of_passing: '',
                        roll_number: '',
                        university: '',
                        subjects: '',
                        percentage: '',
                    },
                    {
                        name: 'Postgraduation',
                        year_of_passing: '',
                        roll_number: '',
                        university: '',
                        subjects: '',
                        percentage: '',
                    },
                ],
                other_skills: '',
                holiday_list: '',
                documents: [],

            },
            employees: [
                {id: 1, name: 'John Doe'},
                {id: 2, name: 'Jane Smith'},
                // Add more employees as needed
            ],
            currentDate: new Date().toISOString().split('T')[0],

            documentUploads: [
                {
                    selectedFile: null, // Stores the selected file
                    name: '', // Stores the document name
                    uploaded: false, // Track if the document is uploaded
                },
            ], // Array to store multiple document upload fields
        }
    },
    methods: {
        fileAdded(fileItem, index) {
            // Store the selected file for the specific document upload section
            this.documentUploads[index].selectedFile = fileItem.file

            // Generate a preview for image files or other supported types
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.documentUploads[index].preview = e.target.result // Set the preview URL
                }
                reader.readAsDataURL(file)
            }

        },
        addQualification() {
            this.form.qualifications.push({name: '', percentage: ''})
        },
        onFileUploaded(error, file) {
            if (error) {
                console.error('File upload error:', error)
                return
            }
            console.log('File uploaded:', file)
        },
        removeQualification(index) {
            this.form.qualifications.splice(index, 1)
        },
        submitForm() {
            //  this.form.processing = true
            // Handle form submission logic
            // After submission reset form.processing to false
        },
        addMoreDocument() {
            // Add a new document upload field to the array
            this.documentUploads.push({
                selectedFile: null,
                name: '',
                uploaded: false,
                preview: null,
            })
        },
        isImage(fileUrl) {
            // Check if the file is an image by its MIME type
            return fileUrl && fileUrl.startsWith('data:image')
        },

        /*   handleAdd() {
               const newId = Date.now();
               this.rowUpdate = {
                   edit: true,
                   id: newId,
                   action: "add",
                   // The default add position is at the top of the list. Use the below prop to insert a new row to the very end.
                   // addPosition: "end",
                   data: {
                       id: newId,
                       age: null,
                       name: "",
                       department: 1,
                       dateOfBirth: null,
                       isActive: false,
                   },
               };
           },
           handleSubmit(data, update) {
               this.rowUpdate = {
                   edit: false,
                   id: data.id,
                   action: update ? "update" : "cancel",
               };
           },
           handleEdit(data) {
               this.rowUpdate = { edit: true, id: data.id };
           },
           handleDelete(data) {
               this.rowUpdate = { id: data.id, action: "delete" };
           },
           validateName(value) {
               if (value === "") {
                   return {
                       valid: false,
                       errorMessage: "Please enter name",
                   };
               }
               return { valid: true };
           },*/
    },
}
</script>
